(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};



	const initVariantLabels = () => {
		const labelsEl = document.querySelector('.product__popup-variant-labels');
		if (!labelsEl) return;

		let optionNames;
		try {
			optionNames = JSON.parse(labelsEl.dataset.variantOptions || '[]');
		} catch {
			return;
		}

		const esc = (str) => {
			const d = document.createElement('div');
			d.textContent = str;
			return d.innerHTML;
		};

		document.addEventListener('variant:change', (e) => {
			const variant = e.detail?.variant;
			if (!variant || !labelsEl.isConnected) return;

			labelsEl.innerHTML = optionNames
				.map((name, i) => {
					const value = variant[`option${i + 1}`];
					if (!value) return '';
					return `<span class="product__popup-variant-label">` +
						`<span class="product__popup-variant-label__name">${esc(name)}:</span>` +
						`<span class="product__popup-variant-label__value"> ${esc(value)}</span>` +
						`</span>`;
				})
				.join('');
		});
	};

	const initDesktopBarScroll = () => {
		const popup = document.querySelector('.product__popup');
		const sectionId = popup?.dataset.sectionId;
		if (!popup || !sectionId) return;

		const variantPicker = document.getElementById(`variant-radios-${sectionId}`)
			?.closest('.product-parameters');
		if (!variantPicker) return;

		popup.addEventListener('click', (e) => {
			const submitBtn = e.target.closest('.product__popup_main .product-form__submit');
			if (!submitBtn) return;
			e.preventDefault();
			const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
			const top = variantPicker.getBoundingClientRect().top + window.scrollY - headerHeight;
			window.scrollTo({ top, behavior: 'smooth' });
		});
	};

	const revealPopup = () => {
		const stickyBar = document.querySelector('.product__popup');
		const buyButtons = document.querySelector('.sticky-button-wrapper, .product__buy_buttons');

		if (!stickyBar || !buyButtons) return;

		const getDocumentBottom = (el) => {
			let top = 0;
			let node = el;
			while (node) {
				top += node.offsetTop;
				node = node.offsetParent;
			}
			return top + el.offsetHeight;
		};

		const triggerBottom = getDocumentBottom(buyButtons);

		const update = () => {
			stickyBar.classList.toggle('active', window.scrollY > triggerBottom);
		};

		window.addEventListener('scroll', update, { passive: true });
		update();
	};

	const initFloatedDrawer = () => {
		const drawer = document.querySelector('.product__popup-drawer');
		if (!drawer) return;

		const panel = drawer.querySelector('.product__popup-drawer__panel');
		const formContainer = drawer.querySelector('.product__popup-drawer__form');
		const openBtn = document.querySelector('[data-floated-drawer-open]');
		let formLoaded = false;

		const openDrawer = () => {
			if (!formLoaded) {
				const floatedForm = document.createElement('floated-form');
				floatedForm.className = 'floated-form no-js-hidden';
				floatedForm.id = 'FloatedForm-Drawer';
				floatedForm.dataset.productUrl = drawer.dataset.productUrl;
				formContainer.appendChild(floatedForm);
				formLoaded = true;
			}
			drawer.hidden = false;
			document.body.style.overflow = 'hidden';
			openBtn?.setAttribute('aria-expanded', 'true');
			panel?.focus();
		};

		const closeDrawer = () => {
			drawer.hidden = true;
			document.body.style.overflow = '';
			openBtn?.setAttribute('aria-expanded', 'false');
			openBtn?.focus();
		};

		openBtn?.addEventListener('click', openDrawer);

		drawer.querySelectorAll('[data-floated-drawer-close]').forEach((el) => {
			el.addEventListener('click', closeDrawer);
		});

		drawer.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') closeDrawer();
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		revealPopup();
		initFloatedDrawer();
		initDesktopBarScroll();
		initVariantLabels();
	});

	initProductAccordion();
	initZoomImage();
	revealPopup();
	initFloatedDrawer();
	initDesktopBarScroll();
	initVariantLabels();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).click(function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations"
		);
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const vendor = this.productElement.querySelector(".product__vendor");
		if (vendor) vendor.remove();

		this.productElement.querySelectorAll(".product-info-item").forEach((el) => el.remove());
		this.productElement.querySelectorAll(".product-collapsible-row").forEach((el) => el.remove());
		this.productElement.querySelectorAll("delivery-countdown").forEach((el) => el.remove());
		this.productElement.querySelectorAll(".product-divider").forEach((el) => el.remove());
		this.productElement.querySelectorAll(".installment-wrapper").forEach((el) => el.remove());

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);
